

export class TyreBrandStatusInput implements ITyreBrandStatusInput {
    /** The auto-generated id of the tyre brand master */
    tyreBrandId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: ITyreBrandStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyreBrandId = _data["tyreBrandId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TyreBrandStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreBrandStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyreBrandId"] = this.tyreBrandId;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITyreBrandStatusInput {
    /** The auto-generated id of the tyre brand master */
    tyreBrandId: number;
    /** The updated status */
    status: number;
}

